import { Checkbox, CheckboxProps } from '@mui/material';
import { Table } from '@tanstack/react-table';

interface IDataTableHeaderCheckboxProps<DataType extends object> extends CheckboxProps {
	table: Table<DataType>;
}

export const DataTableHeaderCheckbox = <DataType extends object>({ table, ...props }: IDataTableHeaderCheckboxProps<DataType>) => {
	return (
		<Checkbox
			size="small"
			{...props}
			checked={table.getIsAllRowsSelected()}
			indeterminate={table.getIsSomeRowsSelected()}
			onChange={table.getToggleAllRowsSelectedHandler()}
		/>
	);
};
